import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', to: '/' },
    { label: '恋爱漫画', to: '/category/love' },
    { label: '奇幻漫画', to: '/category/fantasy' },
    { label: '动作漫画', to: '/category/action' },
    { label: '惊悚漫画', to: '/category/thriller' },
    { label: '耽美漫画', to: '/category/bl' },
    { label: '剧情漫画', to: '/category/drama' },
  ],
  about: [
    { label: '关于我们', to: '/about' },
    { label: '品牌故事', to: '/about#brand' },
    { label: '合作联系', to: '/about#contact' },
    { label: '版权声明', to: '/about#copyright' },
    { label: '用户协议', to: '/' },
  ],
  social: [
    { label: '微博', icon: 'ri-weibo-line', to: '#' },
    { label: '微信公众号', icon: 'ri-wechat-line', to: '#' },
    { label: 'Bilibili', icon: 'ri-bilibili-line', to: '#' },
    { label: '小红书', icon: 'ri-red-packet-line', to: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 max-w-[1200px] mx-auto">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block font-heading text-2xl font-bold mb-6 cursor-pointer">
              韩国漫画网
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              韩国免费漫画在线阅读平台，提供海量韩漫资源，下拉式全集阅读体验。每日更新，分类清晰，为您带来最便捷的韩漫阅读服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">关于</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">关注我们</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.social.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.to}
                    className="flex items-center gap-3 text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={link.icon}></i>
                    </span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 max-w-[1200px] mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 韩国漫画网 - 韩漫大全
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>ICP备2026XXXXXX号</span>
              <span>网络文化经营许可证</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}